module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "endTime": _vm.endTime,
      "callback": _vm.callback,
      "endText": _vm.endText
    }
  }, [_vm._t("default", function() {
    return [_vm._v("\n    " + _vm._s(_vm.content) + "\n  ")]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-519957eb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/countDown.vue
// module id = 630
// module chunks = 0